import { URL_SERVICIOS } from 'src/app/config/config';
import { Injectable } from '@angular/core';

import { resolve } from 'url';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class SubirarchivoService {

  constructor(
    private http: HttpClient
  ) { }


  subirArchivo( archivo: File, tipo: string, id: string ) {

    return new Promise ( ( resolve, reject) => {
 const formData = new FormData();
 const xhr = new XMLHttpRequest();


 formData.append ( 'imagen', archivo, archivo.name);



 xhr.onreadystatechange = () => {
      if ( xhr.readyState === 4) {
        if (xhr.status === 200 ) {

          console.log ('demost', xhr.response);
          resolve ( xhr.response);
        } else {
            console.log ( ' fallo la subida');
            resolve ( xhr.response);
          }
        }
      };

      console.log ('tio', formData);
 let url = URL_SERVICIOS + '/upload/' + tipo + '/' + id  ;
 xhr.open ('PUT', url , true);
 xhr.send ( formData );

    });
  }



  subirArchivoyrenombra( archivo: File, tipo: string, id: string, nuevonombrearchivo: string) {

    return new Promise ( ( resolve, reject) => {
 const formData = new FormData();
 const xhr = new XMLHttpRequest();


 formData.append ( 'imagen', archivo, archivo.name);



 xhr.onreadystatechange = () => {
      if ( xhr.readyState === 4) {
        if (xhr.status === 200 ) {

          console.log (xhr.response);
          resolve ( xhr.response);
        } else {
            console.log ( ' fallo la subida');
            resolve ( xhr.response);
          }
        }
      };


 let url = URL_SERVICIOS + '/uploadfile/' + tipo + '/' + id + '/' + nuevonombrearchivo ;
 xhr.open ('PUT', url , true);
 xhr.send ( formData );

    });
  }



  


  comprobarArchivoValido (nuevonombrearchivo: string) {
    const url = URL_SERVICIOS + '/descargapdf/compruebaxls/'+ nuevonombrearchivo;
    return this.http.get ( url );
  }












}
